import React, { useId, useRef, useState, useSyncExternalStore } from "react";
import { FiDownload, FiX } from "react-icons/fi";
import {
  dismissInstall, getInstallSnapshot, requestWebAppInstall, subscribeInstall,
} from "../utils/webAppInstall";
import "./WebAppInstall.css";

export default function WebAppInstall({ variant = "default", persistent = false }) {
  const { standalone, apple, prompt, dismissed } = useSyncExternalStore(subscribeInstall, getInstallSnapshot);
  const [expanded, setExpanded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const trigger = useRef(null);
  const helpId = useId();
  if (standalone || (!persistent && dismissed) || (!apple && !prompt && !busy && !error)) return null;

  const install = async () => {
    if (apple) { setExpanded((value) => !value); return; }
    setBusy(true);
    setError("");
    try { await requestWebAppInstall(); }
    catch { setError("Installation is unavailable right now. Try your browser's Install app menu."); }
    finally { setBusy(false); }
  };
  const closeHelp = () => { setExpanded(false); trigger.current?.focus(); };

  return (
    <div className={`sbs-install sbs-install--${variant}`}>
      <div className="sbs-install-row">
        <button ref={trigger} type="button" className="sbs-install-trigger" onClick={install}
          disabled={busy} aria-expanded={apple ? expanded : undefined} aria-controls={apple ? helpId : undefined}>
          <FiDownload aria-hidden="true" />
          <span>{busy ? "Opening install options..." : "Install Selenne Business Suite"}</span>
        </button>
        {!persistent && <button type="button" className="sbs-install-dismiss" aria-label="Dismiss installation suggestion" onClick={dismissInstall}><FiX aria-hidden="true" /></button>}
      </div>
      {expanded && apple && <div id={helpId} className="sbs-install-help" onKeyDown={(event) => { if (event.key === "Escape") closeHelp(); }}>
        <p>Open SBS in Safari, then:</p>
        <ol>
          <li>Tap the Share button in Safari.</li>
          <li>Choose <strong>Add to Home Screen</strong>.</li>
          <li>Make sure <strong>Open as Web App</strong> is enabled, if shown.</li>
          <li>Tap <strong>Add</strong>.</li>
        </ol>
        <p>You may need to sign in again when you first open the app from your Home Screen. An internet connection is required.</p>
        <button type="button" onClick={closeHelp}>Close instructions</button>
      </div>}
      {error && <p className="sbs-install-help" role="status">{error}</p>}
    </div>
  );
}
